import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'temperature', 'Temperature', [["path",{"d":"M10 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5"}],["path",{"d":"M10 9l4 0"}]]);